<template>
  <div class="inscription mb-5">
    <form @submit.prevent="submit">
      <div class="half">
        <div>
          <label for="nom">Nom</label>
          <input type="text" id="nom" v-model="nom" required>
        </div>
        <div>
          <label for="prenom">Prénom</label>
          <input type="text" id="prenom" v-model="prenom" required>
        </div>
      </div>
      <div>
        <label for="email">Email</label>
        <input type="email" id="email" v-model="userEmail" required>
      </div>
      <div>
        <label for="password">Mot de passe</label>
        <div class="passContainer">
            <input type="password" id="password" v-model="userPassword" required>
            <span @click="togglePasswordVisibility">
                <svg v-if="showPass == 0" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                </svg>
                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
                <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
                <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
                </svg>
            </span>
        </div>
     

    </div>
      <div>
        <label for="role">Rôle</label>
        <select id="role" v-model="userRole" required>
          <option value="admin">Administrateur</option>
          <option value="gestion">Gestion</option>
          <option value="production">Production</option>
          <option value="be">Bureaux d'étude</option>
          <option value="achats">Achats</option>
          <option value="client">Client</option>
          <option value="reception">Réception</option>
          <option value="approvisionnement">Approvisionnement</option>
          <option value="comptabilite">Comptabilité</option>
        </select>
      </div>
      <div class="half">
        <div v-if="userRole === 'client'">
          <label for="client">Client</label>
          <select v-model="selectedClient" required>
            <option value="">Choix du client</option>
            <option v-for="client in clients" :key="client.nom" :value="client.cocli">{{ client.nom }}</option>
          </select>
        </div>
        <div v-if="userRole === 'client'">
          <label for="magasin">Magasin</label>
          <select v-model="selectedMag" required>
            <option value="">Choix du magasin</option>
            <option v-for="magasin in magasins" :key="magasin.id" :value="magasin.id_magasins">{{ magasin.nom_magasins }}</option>
          </select>
        </div>
      </div>
      
      <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-square-fill" viewBox="0 0 16 16">
        <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3a.5.5 0 0 1 1 0z"/>
      </svg>Ajouter le compte</button>
      <div v-if="confirmationMessage" class="alert alert-success" role="alert">
        {{ confirmationMessage }}
      </div>
      <div v-if="emailExist" class="alert alert-danger" role="alert">
        {{ emailExist }}
      </div>
    </form>
    
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'

export default {
  data() {
    return {
      magasins: [],
      clients: [],
      selectedMag: '',
      selectedClient: '',
      userEmail: '',
      userPassword: '',
      userRole: 'admin',
      emailExist: '',
      confirmationMessage: '',
      showPass:0,
      nom:'',
      prenom:'',
    }
  },
  mounted() {
     

      axios.get('https://www.simef.fr/espace-client/api/getMagasins.php')
      .then(response => {
        this.magasins = response.data;
      })
      .catch(error => {
        console.error(error);
        
      });

      axios.get('https://www.simef.fr/espace-client/api/getClientsAll.php')
      .then(response => {
        this.clients = response.data;
      })
      .catch(error => {
        console.error(error);
        
      });
  },
  methods: {
      submit() {
          console.log("userEmail: ", this.userEmail);

          // Envoyer les données d'inscription au serveur
          axios.post('https://www.simef.fr/espace-client/api/inscription.php', {
              userEmail: this.userEmail,
              userPassword: this.userPassword,
              userRole: this.userRole,
              nom: this.nom,
              prenom: this.prenom,
              selectedMag: this.selectedMag,
              selectedClient: this.selectedClient
          })
          .then(response => {
              this.userEmail = '';
              this.userPassword = '';
              this.userRole = 'admin';
              this.nom = '';
              this.prenom = '';
              this.selectedMag = '';
              this.selectedClient = '';
              

              // Rediriger vers une page de confirmation d'inscription
              this.emailExist = response.data.error;
              this.confirmationMessage = response.data.success;
          })
          .catch(error => {
              console.error(error);
              this.refusMessage = "Une erreur est survenue";
          });
      },
      togglePasswordVisibility() {
          const passwordInput = document.getElementById('password');
          if (passwordInput.type === 'password') {
              passwordInput.type = 'text';
              this.showPass = 1;
          } else {
              passwordInput.type = 'password';
              this.showPass = 0;
          }
      },
      logout() {
        VueCookies.remove('session')
        VueCookies.remove('email')
        VueCookies.remove('role')
        VueCookies.remove('magasin')
        VueCookies.remove('nom')
        VueCookies.remove('prenom')
        VueCookies.remove('token');
        this.loggedInEmail = null
        this.loggedInRole = null
        this.loggedInPrenom = null
        this.loggedInNom = null
        this.loggedInMagasin = null
        this.redirectToLogin(); // Redirige vers la page de connexion après la déconnexion.

      },
      redirectToLogin() {
        this.$router.push('/'); // Remplacez '/connexion' par le chemin de votre page de connexion.
      },
  }
}
</script>

<style lang="scss">

  $primary: #2b358d;
  .inscription, .connexion {
    form {
      background: #f2f2f2;
      padding: 50px;
      text-align: left;
      color: #1d1d20;
      font-weight: 500;
      .half {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          div {
            width: 49.5%;
          }
      }
      input, select {
          width: 100%;
          border: 1px solid #d4d4d4;
          padding: 10px;
          line-height: initial;
          margin-bottom: 10px;
      }
      label,input {
        display: block;
      }
  }
 
  }
 
  
  

  .alert {
    margin-top: 20px;
  }
  .passContainer {
    position: relative;
  }
  .passContainer span {
      position: absolute;
      top: 50%;
      transform: translate(-50%,-50%);
      right: 0%;
      display: flex;
      align-items: center;
  }
</style>